import React from "react";
import "./styles.css";
import TramyCard from "../UI/tramy-card";
import { featuresArray } from "../../constants/contents";

function Features() {
  return (
    <div className="features">
      <h1>
        Solo necesitas 1 número de WhatsApp para vender más y atender rápido a
        tus clientes.
      </h1>
      <div className="features__cards">
        {featuresArray.map((feature) => (
          <TramyCard
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
    </div>
  );
}

export default Features;
